import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './genericModal.component.html'
})

export class GenericModalComponent {

  constructor(public dialogRef: MatDialogRef<GenericModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  confirm() {
    this.dialogRef.close({ confirm: true });
  }
  closeModal() {
    this.dialogRef.close();
  }
}
